import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';

const Root = styled(Horizontal)`
  color: var(--c-nd-900);
  background-color: var(--c-nd-200);
  border-radius: var(--unit);
  padding: var(--half-unit) var(--unit);
`;

export const LimitReached = () => (
  <Root>
    <LabelS as="span" color="var(--c-nd-900)">
      <FormattedMessage
        id="ClubShop.Item.Label.LimitReached"
        defaultMessage="Limit reached"
      />
    </LabelS>
  </Root>
);
